export default {
  emailRegExp:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

  links:
    /\b(?:https?:\/\/[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+|www\.[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+|(?<!https?:)[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+)\b/,

  httpsRegExp: /(http(s?)):\/\//i,

  httpsXmlRegExp: /^https:\/\/.*$/,

  emailDomainRegExp:
    /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/,

  ipRegExp:
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi,

  numberRegExp: /^[0-9]*$/,

  htmlTagsRegExp: /(<([^>]+)>)/gi,

  alphaNumericCharacters: /^[a-z0-9_ ]+$/i,

  folderPathRegExp: /^(\.?[a-zA-Z_-]+\/)+$/,

  figcaption: /<figcaption(.*?)<\/figcaption>/g,

  specialCharacters: /[!@#$%^&*()_+{}\\[\]:;"'<>,.?/~`|-]/,

  specialCharactersExcludeUnderscore: /[!@#$%^&*()+{}\\[\]:;"'<>,.?/~`|-]/,

  usersIdsFromString: /{{([^}]+)}}/g,

  usNumberRegExp:
    /(?<!\S)(?:\+1[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4,10}(?!\S)/g,

  emptySpaces: /^\s*$/,

  hexColorRegExp: /^#([0-9a-fA-F]{6})$/,

  csvFile: /(^text\/csv$|^application\/csv$)/i,

  xlsFile:
    /(application\/vnd\.ms-excel|application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|application\/excel|application\/x-excel|application\/x-msexcel)/i,

  zipFile: /zip|compressed|x-zip/i,

  phoneRegExp: /^[+\d][\d\s\-()]*$|^$/,
}
